import { LanguageId } from 'lib-knowledge-management-common/graphql';
import { z } from 'zod';

import {
  categorySchema,
  collectionSchema,
} from '../categoryEditModal/categoryEditModalSchema';

const parentRef = z.union([categorySchema, collectionSchema]);
export type ParentRef = z.infer<typeof parentRef>;
export const categoryAddModalSchema = z.object({
  language: z.object({ id: z.enum(LanguageId), name: z.string() }),
  categoryTitle: z.string().min(1, { error: 'Category name is required' }),
  parentRef,
});
export type CategoryAddModalSchema = z.infer<typeof categoryAddModalSchema>;
